var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app dashboard"},[_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1),(_vm.loading)?_c('v-card',[_c('div',{staticClass:"fakeLoader"},[_c('div',{staticClass:"fl fl-spinner spinner4"})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }